import React, { Component } from 'react';
import './App.css';
import { Provider } from 'react-redux';
import store from './store/rootStore';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Form from './Views/Form';
import Verify from './Views/Verify';
import Toolbar from '@mui/material/Toolbar';
import FormError from './Views/FormError';
import { CssBaseline, GlobalStyles, ThemeProvider, StyledEngineProvider } from '@mui/material';
import importedTheme from './theme';

// form preview
import FormPreview from './Views/FormPreviews/FormPreview';
import BulkAssessment from './Views/BulkAssessment/BulkAssessment';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import awsconfigGG, { currentDomain } from './auth/awsConfig';
import FormWaiting from './Views/FormWaiting';

// Configure Amplify with the same cookie storage as parent app for session sharing
Amplify.configure(awsconfigGG);

// Configure cookie storage to match parent app - this enables automatic session sharing
cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: currentDomain,
    sameSite: 'none',
    secure: true,
    path: '/',
  })
);

// Use the imported theme directly
const customTheme = importedTheme;

class App extends Component {
  createAppBar = () => {
    return (
      <nav
        id="main-header"
        style={{ zIndex: '-100', position: 'unset' }}
        className="navbar navbar-expand-lg navbar-light fixed-top text-right "
      >
        <div
          className="container"
          style={{ maxWidth: 1500, textAlign: 'right' }}
        >
          <a className="navbar-brand" href="https://www.workflow86.com/">
            <img src="/images/w86_logo.png" width="40" alt="" />
          </a>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto"></ul>
          </div>
        </div>
      </nav>
    );
  };

  createFooter = () => {
    return (
      <div className="footer" style={{ backgroundColor: 'rgb(44,44,44)' }}>
        <Toolbar></Toolbar>
      </div>
    );
  };

  render() {
    return (
      <ThemeProvider theme={customTheme}>
        <StyledEngineProvider injectFirst>
          <CssBaseline />
          <GlobalStyles
            styles={(theme) => ({
              ':root': {
                '--font-family-body': '"Open Sans", sans-serif',
                '--color-bg-default': theme.palette.background.default || '#FFFFFF',
                '--color-bg-paper': theme.palette.background.paper || '#FFFFFF',
                '--color-bg-subtle': '#f6f6f6',
                '--color-text-primary': theme.palette.text.primary,
                '--color-text-secondary': theme.palette.text.secondary,
                '--color-text-disabled': theme.palette.text.disabled,
                '--color-divider': theme.palette.divider,
                '--color-border': theme.palette.divider,
                '--color-primary': theme.palette.primary.main,
                '--color-primary-contrast': theme.palette.primary.contrastText,
                '--color-error': theme.palette.error.main,
                '--color-success': theme.palette.success.dark || '#047857',
                '--color-warning': theme.palette.warning.main,
                '--color-info': theme.palette.info.main,
                '--color-action-hover': 'rgba(0, 0, 0, 0.04)',
                '--color-action-selected': 'rgba(0, 0, 0, 0.08)',
                '--status-green-color': '#059669',
                '--status-green-bg': '#ecfdf5',
                '--status-green-border': '#a7f3d0',
                '--status-red-color': '#dc2626',
                '--status-red-bg': '#fef2f2',
                '--status-red-border': '#fecaca',
                '--status-amber-color': '#856404',
                '--status-amber-bg': '#fff3cd',
                '--status-amber-border': '#ffeaa7',
                '--status-blue-color': '#1d4ed8',
                '--status-blue-bg': '#eff6ff',
                '--status-blue-border': '#dbeafe',
                '--status-purple-color': '#7c3aed',
                '--status-purple-bg': '#f5f3ff',
                '--status-purple-border': '#ede9fe',
                '--status-chip-radius': '5px',
              },
            })}
          />
          <Provider store={store}>
            <Router
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}
            >
              <Routes>
                <Route path="/" element={<Verify />} />
                <Route
                  path="/form/form_test/:form_id/:test_id/:session_id"
                  element={<Form />}
                />
                <Route
                  path="/form/form_test/:form_id/:test_id"
                  element={<Form />}
                />
                <Route
                  path="/form/form_preview/:form_id/:projectVersion/:session_id"
                  element={<FormPreview />}
                />
                <Route
                  path="/form/form_preview/:form_id/:projectVersion"
                  element={<Form />}
                />
                <Route
                  path="/form/:form_id/:session_id/:project_session_id"
                  element={<FormWaiting isTest={false} />}
                />
                <Route
                  path="/form_test/:form_id/:session_id/:project_session_id/:test_id"
                  element={<FormWaiting isTest={true} />}
                />
                <Route path="/form/:form_id/:session_id" element={<Form />} />
                <Route path="/form/:form_id" element={<Form />} />
                <Route path="/form" element={<Verify />} />
                <Route path="/form_error/:error_type" element={<FormError />} />
                <Route path="/form_error" element={<FormError />} />
                <Route
                  path="/bulk/bulk_test/:component_id/:test_id"
                  element={<BulkAssessment />}
                />
                <Route
                  path="/bulk/:component_id"
                  element={<BulkAssessment />}
                />
              </Routes>
            </Router>
          </Provider>
        </StyledEngineProvider>
      </ThemeProvider>
    );
  }
}

export default App;
